/**
 * Embed protocol version.
 *
 * This version is used in the embed URL path (e.g., /embed/v1/[appId])
 * and in the message protocol to ensure compatibility between the
 * host packages (@yak-io/javascript, @yak-io/react, @yak-io/nextjs)
 * and the embedded chat UI.
 *
 * Increment this version when making breaking changes to:
 * - The postMessage protocol (IframeMessageFromHost, IframeMessageToHost)
 * - The tool manifest format
 * - The route manifest format
 * - The config payload structure
 *
 * Version history:
 * - v1: Initial versioned protocol
 */
export const EMBED_PROTOCOL_VERSION = "1" as const;

/**
 * Type for the embed protocol version
 */
export type EmbedProtocolVersion = typeof EMBED_PROTOCOL_VERSION;
